import { render, staticRenderFns } from "./RevenueChartTwo.vue?vue&type=template&id=6e641e63&"
import script from "./RevenueChartTwo.vue?vue&type=script&lang=js&"
export * from "./RevenueChartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports